import { Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { SeriesService } from '../series.service';
import { UpdateSeries } from '../series.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-edit-section',
    templateUrl: './edit-section.component.html',
    styleUrls: ['./edit-section.component.scss'],
})
export class EditSectionComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    serii = [
        { id: -1, name: '--Alegeți--' },
        { id: 1, name: 'Resetare anuală' },
        { id: 2, name: 'Numărătoare continuă' },
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        slug_seq: new FormControl(this.data.slug_seq, [Validators.required]),
        seq_prefix: new FormControl(this.data.seq_prefix, []),
        first_number: new FormControl(this.data.first_number, [Validators.required]),
        numar_start: new FormControl(this.data.numar_start, []),
        numar_end: new FormControl(this.data.numar_end, []),
        serie_type: new FormControl(this.data.serie_type, [Validators.required, notDefaultValidator('-1')]),
        observatii: new FormControl(this.data.observatii, []),
    }, { validators: this.rangeValidator() });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditSectionComponent>,
        private requestService: SeriesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    rangeValidator(): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const numarStartControl = formGroup.get('numar_start');
            const numarEndControl = formGroup.get('numar_end');

            if (!numarStartControl || !numarEndControl) {
                return null;
            }

            const numarStart = numarStartControl.value;
            const numarEnd = numarEndControl.value;

            // Dacă ambele câmpuri sunt goale, nu validăm
            if (!numarStart || !numarEnd) {
                // Clear any existing error
                if (numarEndControl.hasError('rangeInvalid')) {
                    numarEndControl.setErrors(null);
                }
                return null;
            }

            const start = Number(numarStart);
            const end = Number(numarEnd);

            // Verificăm dacă start este mai mare sau egal cu end
            if (start >= end) {
                numarEndControl.setErrors({ rangeInvalid: true });
            } else {
                // Clear the error if the range is valid
                if (numarEndControl.hasError('rangeInvalid')) {
                    numarEndControl.setErrors(null);
                }
            }

            return null;
        };
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, slug_seq, seq_prefix, first_number, numar_start, numar_end, serie_type, observatii } = this.form.value;
        const payload: UpdateSeries = {
            id: this.data.id,
            name,
            slug,
            slug_seq,
            seq_prefix,
            numar_start,
            numar_end,
            first_number,
            serie_type,
            observatii
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
